import {TicketType} from '../../../../graphql/generated/types';
import {AttemptToBuyTicketInfo} from '../type';

/**
 * 이용권충전 화면에서 바로보기 시 사용할 티켓 타입
 * @param attemptToBuyTicketInfo
 */
export function pickDirectUseTicketType(
  attemptToBuyTicketInfo: AttemptToBuyTicketInfo
): TicketType | undefined {
  if ('ticketType' in attemptToBuyTicketInfo) {
    return attemptToBuyTicketInfo.ticketType;
  }
  if (!('chunkList' in attemptToBuyTicketInfo)) {
    return undefined;
  }
  const ticketChunkIndex = attemptToBuyTicketInfo.chunkList.findIndex(chunk =>
    [TicketType.BuySingle, TicketType.RentSingle].includes(
      chunk.ticket.ticketType
    )
  );
  return attemptToBuyTicketInfo.chunkList[
    ticketChunkIndex > -1 ? ticketChunkIndex : 0
  ].ticket.ticketType;
}
